<section class="product__bottomLinks">
  <div class="innerContainer">
    <div class="vc-title-xs productBottomLinks__title" i18n="@@SUGGESTIONS.YOU_MIGHT_ALSO_LIKE">
      You might also like
    </div>
    <div class="productBottomLinks__container">
      <vc-ref
        *ngFor="let link of bottomLinks"
        [anchor]="false"
        [resource]="link.url.path"
        [extraClass]="'vc-btn vc-btn--secondary vc-btn--small'"
        class="productBottomLinks__link"
      >
        {{ link.localizedName }}
      </vc-ref>
    </div>
  </div>
</section>
